module.exports = __webpack_public_path__ + "img/logo.5218c503.png";